import { b as bootstrapLazy } from './index-CThqyo-c.js';
export { s as setNonce } from './index-CThqyo-c.js';
import { g as globalScripts } from './app-globals-DQuL1Twl.js';
const defineCustomElements = async (win, options) => {
  if (typeof window === 'undefined') return undefined;
  await globalScripts();
  return bootstrapLazy([["ix-siemens-logo", [[1, "ix-siemens-logo"]]]], options);
};
export { defineCustomElements };


